import { useMemo } from "react";
import { t } from "@/i18n-js/instance";
import { usePunditUserContext } from "@circle-react/contexts";
import { isChatSpace } from "@circle-react/helpers/spaceHelpers";
import type { Space } from "@circle-react/types";
import { Form } from "@circle-react-shared/uikit/Form";
import { Dropdown } from "@circle-react-uikit/Dropdown";
import { NotificationOptionCheckbox } from "./NotificationOptionCheckbox";

const NOTIFICATION_TYPES_OPTIONS = [
  {
    value: "notification_type",
    label: t("notification_settings.notification_type"),
  },
  {
    value: "in_app_notification_setting",
    label: t("notification_settings.in_app_notification_setting"),
  },
  {
    value: "mobile_notification_setting",
    label: t("notification_settings.mobile_notification_setting"),
  },
];

export interface NotificationsSectionProps {
  updateSpaceMemberNotificationPreferences: (args: {
    fieldKey: string;
    shouldEnable: boolean;
  }) => void;
  notificationState: any;
  space: Space;
}

export const NotificationsSection = ({
  updateSpaceMemberNotificationPreferences,
  notificationState,
  space,
}: NotificationsSectionProps) => {
  const { currentCommunity } = usePunditUserContext();
  const isSpaceChatSpace = isChatSpace(space);

  const notificationTypes = useMemo(
    () =>
      NOTIFICATION_TYPES_OPTIONS.filter(notificationType => {
        if (notificationType.value === "mobile_notification_setting") {
          return (
            currentCommunity?.ios_app_enabled ??
            currentCommunity?.has_branded_app
          );
        }
        if (notificationType.value === "notification_type") {
          return !isSpaceChatSpace;
        }
        return true;
      }),
    [currentCommunity, isSpaceChatSpace],
  );

  const onChange = (fieldKey: string, shouldEnable: boolean) => {
    updateSpaceMemberNotificationPreferences({
      fieldKey,
      shouldEnable,
    });
  };

  if (!notificationState) {
    return null;
  }

  return (
    <Form defaultValues={notificationState} onSubmit={() => {}}>
      <Dropdown.Header>
        {isSpaceChatSpace
          ? t("space_header.mention_notifications")
          : t("space_header.notifications")}
      </Dropdown.Header>
      {notificationTypes.map(notificationType => (
        <NotificationOptionCheckbox
          key={notificationType.label}
          isChecked={notificationState[notificationType.value]}
          notificationType={notificationType}
          onChange={onChange}
        />
      ))}
    </Form>
  );
};
